"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var formik_1 = require("formik");
var PostTabsContext_1 = require("../../../contexts/PostTabsContext");
var FocusError = function (_a) {
    var customError = _a.customError;
    var isFormErrors = react_1.useContext(PostTabsContext_1.PostTabsContext).isFormErrors;
    var _b = formik_1.useFormikContext(), errors = _b.errors, isSubmitting = _b.isSubmitting, isValidating = _b.isValidating;
    react_1.useEffect(function () {
        if ((isSubmitting && !isValidating) || isFormErrors || customError) {
            var errorElement = document.querySelector('.invalid-input-error-message');
            if (errorElement) {
                var parent_1 = errorElement.parentNode;
                var input = parent_1.querySelector('input');
                if (input) {
                    input.focus();
                }
            }
        }
    }, [errors, isSubmitting, isValidating, isFormErrors, customError]);
    return null;
};
exports.default = FocusError;
